/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Configuration } from '@azure/msal-browser'
import { Capacitor } from '@capacitor/core'

const nativeRedirectUri =
  Capacitor.getPlatform() === 'android'
    ? process.env.REACT_APP_ANDROID_REDIRECT_SCHEME
    : process.env.REACT_APP_IOS_REDIRECT_SCHEME

const nativeConfig = {
  clientId: process.env.REACT_APP_AZURE_B2C_CLIENT_ID!,
  redirectUri: nativeRedirectUri,
  postLogoutRedirectUri: nativeRedirectUri,
  authority: process.env.REACT_APP_AZURE_B2C_AUTHORITY!,

  knownAuthorities: [
    process.env.REACT_APP_AZURE_B2C_AUTHORITY_PASSWORD_RESET!,
    process.env.REACT_APP_AZURE_B2C_AUTHORITY!,
  ],
}

const webConfig = {
  clientId: process.env.REACT_APP_AZURE_B2C_CLIENT_ID!,
  authority: process.env.REACT_APP_AZURE_B2C_AUTHORITY,
  redirectUri: process.env.REACT_APP_AZURE_B2C_LOGIN_REDIRECT_URI,
  postLogoutRedirectUri: process.env.REACT_APP_AZURE_B2C_LOGOUT_REDIRECT_URI,
  knownAuthorities: [
    process.env.REACT_APP_AZURE_B2C_AUTHORITY!,
    process.env.REACT_APP_AZURE_B2C_AUTHORITY_PASSWORD_RESET!,
  ],
}
// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: Capacitor.isNativePlatform() ? nativeConfig : webConfig,
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
    // tokenRenewalOffsetSeconds: 10000, // 10 seconds renew offset
  },
}

export const scopes = []
